<!--
  StatusPill — vocabolario unico degli STATI.
  Un solo componente per tutti i gestionali: stesso stato = stesso colore,
  ovunque. I colori arrivano dai token --state-* (styles/main.css).

  Uso:  <StatusPill kind="ok" label="Confermato" />
-->
<template>
  <span
    class="pill"
    :class="`pill--${kind}`"
  >{{ label }}</span>
</template>

<script>
export default {
  name: 'StatusPill',
  props: {
    // attn = richiede azione (da assegnare, in conferma, da saldare)
    // ok = confermato/concluso · active = in corso
    // danger = rifiutato · muted = neutro/programmato
    kind: {
      type: String,
      default: 'muted',
      validator: (v) => ['attn', 'ok', 'active', 'danger', 'muted'].includes(v),
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.4;
  white-space: nowrap;
}
/* Il pallino usa currentColor: basta impostare il colore del testo. */
.pill::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}
.pill--attn {
  color: var(--state-attn);
  background: var(--state-attn-bg);
  border-color: var(--state-attn-line);
}
.pill--ok {
  color: var(--state-ok);
  background: var(--state-ok-bg);
  border-color: var(--state-ok-line);
}
.pill--active {
  color: var(--state-active);
  background: var(--state-active-bg);
  border-color: var(--state-active-line);
}
.pill--danger {
  color: var(--state-danger);
  background: var(--state-danger-bg);
  border-color: var(--state-danger-line);
}
.pill--muted {
  color: var(--state-muted);
  background: var(--state-muted-bg);
  border-color: var(--state-muted-line);
}
</style>
